<template>
  <li :class="['margin-right-xxs', attrs && attrs['class']]">
    <a
      :aria-label="buttonAriaLabel"
      :class="[
        'secondary button button-small',
        hasSlot ? 'page-chevron-item' : 'page-number-item',
        { 'active': isActive }
      ]"
      :href="pageLinkUrl"
      :tabindex="attrs && attrs['tabindex']"
      @click.prevent="onClick"
    >
      <slot>{{ pageNumber }}</slot>
    </a>
  </li>
</template>

<script setup>
import {
  computed,
  useAttrs,
  useSlots,
} from 'vue';

import useNumericPaginationItem from '@modules/sortable-grid/composables/useNumericPaginationItem';

const props = defineProps({
  currentPage: {
    required: true,
    type: Number,
  },
  pageNumber: {
    default: 1,
    type: Number,
  },
});

const emit = defineEmits(['item-click']);

const { getPageLinkUrl } = useNumericPaginationItem();

const attrs = useAttrs();
const slots = useSlots();

// If no slot is defined, then is page number (not chevron)
const hasSlot = computed(() => !!slots.default);

const isActive = computed(() => !hasSlot.value && (props.pageNumber === props.currentPage));
const buttonAriaLabel = computed(() => {
  /* istanbul ignore else */
  if (isActive.value) {
    return `Current Page ${props.pageNumber}, Button`;
  }
  return `Page ${props.pageNumber}, Button`;
});

const pageLinkUrl = computed(() => getPageLinkUrl(props.pageNumber));

const onClick = () => {
  emit('item-click', props.pageNumber);
};
</script>

<style lang="scss" scoped>
    li {
        &:last-child {
            margin-right: 0;
        }

        .button {
            align-items: center;
            cursor: pointer;
            display: inline-flex;
            justify-content: center;
            padding: 0;

            &:hover {
                background-color: white;
            }

            &.page-chevron-item {
                height: rem-calc(24);
                width: rem-calc(24);
            }

            &.page-number-item {
                width: rem-calc(40);

                &::after {
                    border-width: rem-calc(1);
                }

                &.active {
                    &::after {
                        border-width: rem-calc(2);
                    }
                }
            }
        }
    }
</style>
